import { NavigateFn } from '@reach/router';
import { CheckoutPayResponse } from 'services/checkout-service/models';
import { extractBasePath } from 'hooks/context/checkoutSession/utils';

export const handleSuccessRedirect = (navigate: NavigateFn, response: CheckoutPayResponse, isInvoiceMode: boolean, checkoutSessionId?: string, successUrl?: string) => {
  // Redirect to merchant specified success url if payment succeeds
  if (!isInvoiceMode && successUrl) {
    // eslint-disable-next-line
    window.location.href = successUrl;

    return;
  }

  const basePath = extractBasePath(window.location.pathname);
  navigate(`/${basePath}/${checkoutSessionId}/confirmation`, {
    replace: true,
    state: { ...response }
  });
};
